import { render, staticRenderFns } from "./UserTabs.vue?vue&type=template&id=37ba8b60&"
import script from "./UserTabs.vue?vue&type=script&lang=js&"
export * from "./UserTabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports